/**
 * Checkout orders paid through ally products' Mercado Pago links
 * (api/_allyOrders.cjs).
 */

export const createAllyOrder = async (body) => {
  const fallbackMessage = 'No se pudo registrar tu pedido. Intenta de nuevo.';
  const response = await fetch('/api/ally-orders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) throw new Error(fallbackMessage);
  const data = await response.json();
  if (!response.ok || data?.success === false) throw new Error(data?.error || fallbackMessage);
  return data.data;
};

/** True when every bag line is an ally product with a Mercado Pago link. */
export const canPayWithMercadoPagoLinks = (items) =>
  items.length > 0 && items.every((item) => item.source === 'ally' && item.mercado_pago_url);

/** True when every bag line is an ally product whose ally accepts bank transfer. */
export const canPayByAllyBankTransfer = (items) =>
  items.length > 0 && items.every((item) => item.source === 'ally' && item.accepts_bank_transfer);

/**
 * Payment method of an ally order (api/_allyOrders.cjs), from its
 * paymentIntentId prefix; null for any other order.
 */
export const allyOrderPaymentMethod = (paymentIntentId) => {
  const id = String(paymentIntentId || '');
  if (id.startsWith('mplink_')) return 'mercado_pago_link';
  if (id.startsWith('allytransfer_')) return 'bank_transfer';
  return null;
};
